/** 发放记录中的团队等级快照，与 giftGiveLevel 展示一致：C0、C1… */
export function formatFortAgentPayoutTeamLevel(teamLevel: number): string {
  const n = Number(teamLevel);
  if (!Number.isFinite(n) || n < 0) return "C0";
  return `C${n}`;
}

/** 发放记录 `rateBpms` → 日收益率百分比（与后端单位对齐后调整除数） */
export function formatFortAgentStaticRateBpms(rateBpms: number): string {
  const n = Number(rateBpms);
  if (!Number.isFinite(n) || n <= 0) return "-";
  return `${(n / 100).toFixed(2)}%`;
}
